
(function(){
  const root=document.getElementById('telas-review');
  root.querySelectorAll('[data-mc-target]').forEach(function(button){
    button.addEventListener('click',function(){
      const target=root.querySelector('#'+button.getAttribute('data-mc-target'));
      if(target)target.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});
    });
  });
  const zoom=root.querySelector('#te-texture-zoom');
  const frame=root.querySelector('.te-texture-frame');
  const caption=root.querySelector('#te-texture-caption');
  zoom.addEventListener('click',function(){
    const expanded=zoom.getAttribute('aria-pressed')!=='true';
    zoom.setAttribute('aria-pressed',String(expanded));
    frame.classList.toggle('te-is-zoomed',expanded);
    zoom.textContent=expanded?'Volver a la vista de detalle −':'Ampliar la textura +';
    caption.textContent=expanded?'Textura ampliada · relieve de la tela.':'Textura de la tela · vista de detalle.';
  });
})();
